import React from 'react';
import { guaranteeSteps } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-114" data-mp="1o46konudlsx5">
      <div className="mx-auto max-w-4xl" data-id="element-115" data-mp="1o5pzsb4apxxc">
        <div className="rounded-3xl bg-white p-3 shadow-soft" data-id="element-116" data-mp="223y2kzo0jtgf">
          <div className="grid items-center gap-8 rounded-[1.25rem] border-2 border-dashed border-brand/30 px-6 py-10 sm:px-10 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-117" data-mp="22128jmfadox9">
            <Seal data-id="element-118" data-mp="19fipiiofzl7q" />

            <div className="text-center md:text-left" data-id="element-119" data-mp="19co8700q6gij">
              <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-120" data-mp="14gfnz87o7x4i">
                Geld zurück <span className="italic text-brand" data-id="element-121" data-mp="1j5vaud42ziex">oder behalten.</span>
              </h2>
              <p className="mt-3 font-display text-lg font-bold text-ink" data-id="element-122" data-mp="1ec98pevjmwxd">
                Teste MATHE BEREIT™ 30 Tage risikofrei.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-123" data-mp="lpg24fvh33fg">
                Wenn es deinen Unterricht nicht leichter macht, bekommst du dein Geld zurück — ohne
                Fragen.
              </p>
            </div>
          </div>
        </div>

        <ol className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-124" data-mp="twi3ox00j7kp">
          {guaranteeSteps.map((step, index) => <li key={step.title} className="flex gap-4 sm:flex-col sm:gap-3" data-id="element-125" data-mp="yrp3htq5vs4c" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-black text-white" data-id="element-126" data-mp="12q4vyd50hsp5">
                {index + 1}
              </span>
              <span data-id="element-127" data-mp="b00hsw7ui1wd">
                <span className="block font-display text-base font-bold text-ink" data-id="element-128" data-mp="b1l98cyv54q0">{step.title}</span>
                <span className="mt-1 block text-sm leading-relaxed text-ink/60" data-id="element-129" data-mp="f3olv4x9qfcv">{step.text}</span>
              </span>
            </li>)}
        </ol>
      </div>
    </section>;
}
function Seal() {
  return <div className="relative mx-auto flex h-40 w-40 shrink-0 items-center justify-center rounded-full bg-brand text-white shadow-soft" role="img" aria-label="30 Tage Geld-zurück-Garantie" data-id="element-130" data-mp="1vfbxlkzriyem">
      <div className="absolute inset-2 rounded-full border-2 border-dashed border-white/50" data-id="element-131" data-mp="3nhwp5pawzwyt" />
      <div className="text-center" data-id="element-132" data-mp="5c1tx9a4effi">
        <span className="block text-[10px] font-bold uppercase tracking-[0.18em]" data-id="element-133" data-mp="5b07y9rkg8j0">Garantie</span>
        <span className="block font-display text-6xl font-black leading-none" data-id="element-134" data-mp="cypnr1ysd8l">30</span>
        <span className="block text-[11px] font-extrabold uppercase tracking-[0.14em]" data-id="element-135" data-mp="38t0jfywbyw1d">Tage</span>
        <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.1em] text-white/80" data-id="element-136" data-mp="33ugvjsy6fa6d">
          Geld zurück
        </span>
      </div>
    </div>;
}